<template>
  <div class="relative mx-auto px-6 md:max-w-full md:px-12 lg:max-w-6xl xl:px-0 mt-16 md:mt-32">
    <h2
      class="text-2xl lg:text-4xl xl:text-5xl font-medium text-gray-800 text-center sm:text-start"
      v-motion
      :initial="{ opacity: 0, y: 50 }"
      :visible-once="{
        opacity: 1,
        y: 0,
        scale: 1,
        transition: {
          delay: 200,
          duration: 800,
          opacity: {
            duration: 800
          }
        }
      }"
    >
      Adaptamos soluciones a medida
      <br class="hidden sm:block" />
      para su industria
    </h2>

    <div class="flex justify-center sm:justify-end mt-2 sm:mt-0">
      <button
        @click="scrollLeft"
        class="hidden sm:block bg-transparent px-3 mr-10 sm:mr-4"
        :disabled="scroll <= 0"
        :class="{ 'opacity-50': scroll <= 0 }"
        :style="{ cursor: scroll <= 0 ? 'not-allowed' : 'pointer' }"
      >
        <Image src="/images/carousel/chevron-left.svg" class="!h-8" alt="" />
      </button>

      <button
        @click="scrollRight"
        class="hidden sm:block bg-transparent sm:mr-4"
        :disabled="scroll > maxScroll"
        :class="{ 'opacity-50': scroll > maxScroll }"
        :style="{ cursor: scroll > maxScroll ? 'not-allowed' : 'pointer' }"
      >
        <Image src="/images/carousel/chevron-right.svg" class="!h-8" alt="" />
      </button>

      <div class="sm:hidden bg-transparent px-3 mr-10 sm:mr-4 opacity-50">
        <Image src="/images/carousel/chevron-left.svg" class="!h-8" alt="" />
      </div>

      <div class="sm:hidden bg-transparent sm:mr-4 opacity-50">
        <Image src="/images/carousel/chevron-right.svg" class="!h-8" alt="" />
      </div>
    </div>
  </div>

  <div
    class="lg:block mx-4 sm:mx-8 xl:mx-16 2xl:mx-32 flex justify-start items-start"
    style="overflow: hidden"
  >
    <div
      class="flex pt-4 sm:pt-6 pb-8 sm:pb-12 md:pb-16 mx-2 gap-4"
      :style="{ transform: `translateX(${-scroll}px)`, transition: 'transform 0.5s ease-in-out' }"
    >
      <div v-for="(item, index) in carouselItems" :key="index" class="w-80">
        <input
          :id="'carousel-' + index"
          class="sr-only peer"
          type="radio"
          :name="'carousel-' + index"
          :checked="index === 0"
        />
        <div
          @click="openLink(item.link)"
          class="hover:cursor-pointer w-80 bg-white rounded-lg shadow-lg transition-all duration-300 opacity-100 peer-checked:opacity-100 peer-checked:z-10 z-0"
        >
          <Image class="rounded-t-lg !w-80 !h-64" :src="item.image" :alt="'Image ' + (index + 1)" />
          <div class="py-4 px-8">
            <h1 class="text-gray-900 font-normal text-base">{{ item.title }}</h1>
          </div>
          <div class="flex justify-end items-center px-4 pb-4">
            <button class="inline-block bg-white bg-transparent active:translate-y-0.5">
              <Image src="/images/cards/right-arrow.png" class="!h-3 opacity-50" alt="" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="lg:hidden">
    <div
      class="flex overflow-x-auto snap-x snap-mandatory -mx-4 p-5 carousel mb-8 sm:mb-12 md:mb-16"
      ref="carousel"
      style="scrollbar-width: none"
    >
      <div
        class="flex pt-4 sm:pt-6 mx-2 gap-4"
        :style="{ transform: `translateX(${-scroll}px)`, transition: 'transform 0.5s ease-in-out' }"
      >
        <div
          class="snap-center shrink-0 first:pl-4 last:pr-4 flex justify-center"
          v-for="(item, index) in carouselItems"
          :key="index"
        >
          <div
            @click="openLink(item.link)"
            class="hover:cursor-pointer w-80 bg-white rounded-lg shadow-lg transition-all duration-300 opacity-100 peer-checked:opacity-100 peer-checked:z-10 z-0"
          >
            <Image
              class="rounded-t-lg !w-80 !h-64"
              :src="item.image"
              :alt="'Image ' + (index + 1)"
            />
            <div class="py-4 px-8">
              <h1 class="text-gray-900 font-normal text-base">{{ item.title }}</h1>
            </div>
            <div class="flex justify-end items-center px-4 pb-4">
              <button class="inline-block bg-white bg-transparent active:translate-y-0.5">
                <Image src="/images/cards/right-arrow.png" class="!h-3 opacity-50" alt="" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { Image } from '@unpic/vue';

const router = useRouter();

const openLink = (link) => {
  router.push(link);
};

const cardData = ref([
  {
    title: 'Gestión en tiempo real de la IA',
    description:
      'Automatice la asignación de clientes potenciales y mejore la atención al cliente con nuestra solución de IA para conversaciones en tiempo real.'
  },
  {
    title: 'Gestión en tiempo real de la IA',
    description:
      'Automatice la asignación de clientes potenciales y mejore la atención al cliente con nuestra solución de IA para conversaciones en tiempo real.'
  },
  {
    title: 'Gestión en tiempo real de la IA',
    description:
      'Automatice la asignación de clientes potenciales y mejore la atención al cliente con nuestra solución de IA para conversaciones en tiempo real.'
  }
]);

const carouselItems = ref([
  {
    image: '/images/carousel/Automotri.png',
    title: 'Automotriz',
    link: '/solutions/automotive'
  },
  {
    image: '/images/carousel/comercioelec.png',
    title: 'Comercio Electrónico',
    link: '/solutions/electronic-commerce'
  },
  {
    image: '/images/carousel/Turismo.png',
    title: 'Turismo',
    link: '/solutions/tourism'
  },
  {
    image: '/images/carousel/Finanza.png',
    title: 'Finanzas',
    link: '/solutions/finance'
  },
  {
    image: '/images/carousel/Negocio.png',
    title: 'Negocio Local',
    link: '/solutions/local-business'
  },
  {
    image: '/images/carousel/wholesale.png',
    title: 'Venta al por Mayor',
    link: '/solutions/wholesale'
  },
  {
    image: '/images/carousel/farmacias.png',
    title: 'Farmacias',
    link: '/solutions/pharmacy'
  }
]);

const scroll = ref(0);
const itemWidth = 336;
const maxScroll = computed(() => (carouselItems.value.length - 2) * itemWidth);

const scrollLeft = () => {
  scroll.value = Math.max(0, scroll.value - itemWidth);
};

const scrollRight = () => {
  console.log(scroll.value, maxScroll.value, carouselItems.value.length);
  scroll.value = Math.min(scroll.value + itemWidth);
};
</script>
